export default __webpack_public_path__ + "static/media/penne-pasta.3a7da1b3.jpg";